import axios from 'axios';
import config from 'config';

export const getToken = () => {
    return axios
        .get(`${config.endpoint.showroom}/service/v1/jwt?userName=public&password=public`)
        .then((response) => Promise.resolve(response.data));
};

export default { getToken };
